import React from 'react';
import { Package, CheckCircle, XCircle, Clock, Tag, TrendingUp } from 'lucide-react';

const ProduitServiceStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Produits/Services',
      value: stats?.total_produits || 0,
      icon: Package,
      color: 'text-[#FF6B00]',
      bgColor: 'bg-orange-100'
    },
    {
      title: 'Actifs',
      value: stats?.produits_actifs || 0,
      icon: CheckCircle,
      color: 'text-[#437011]',
      bgColor: 'bg-green-100'
    },
    {
      title: 'Inactifs',
      value: stats?.produits_inactifs || 0,
      icon: XCircle,
      color: 'text-red-600',
      bgColor: 'bg-red-100'
    },
    {
      title: 'Cette semaine',
      value: stats?.produits_semaine || 0,
      icon: Clock,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100'
    }
  ];

  return (
    <div className="space-y-4">
      {/* Stats principales */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600 mb-1">{stat.title}</p>
                  <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                </div>
                <div className={`${stat.bgColor} p-3 rounded-lg`}>
                  <Icon className={`w-6 h-6 ${stat.color}`} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Stats additionnelles */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center gap-3">
            <div className="bg-purple-100 p-3 rounded-lg">
              <TrendingUp className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Prix moyen</p>
              <p className="text-xl font-bold text-gray-900">
                {Math.round(stats?.prix_moyen || 0).toLocaleString('fr-FR')} FCFA
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center gap-3">
            <div className="bg-green-100 p-3 rounded-lg">
              <Tag className="w-6 h-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Prix minimum</p>
              <p className="text-xl font-bold text-gray-900">
                {Math.round(stats?.prix_min || 0).toLocaleString('fr-FR')} FCFA
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center gap-3">
            <div className="bg-orange-100 p-3 rounded-lg">
              <Tag className="w-6 h-6 text-[#FF6B00]" />
            </div>
            <div>
              <p className="text-sm text-gray-600">Prix maximum</p>
              <p className="text-xl font-bold text-gray-900">
                {Math.round(stats?.prix_max || 0).toLocaleString('fr-FR')} FCFA
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Stats par catégorie */}
      {stats?.stats_categorie && stats.stats_categorie.length > 0 && (
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
            <Tag className="w-5 h-5 text-[#FF6B00]" />
            Répartition par catégorie
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {stats.stats_categorie.map((cat, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-1">{cat.categorie || 'Sans catégorie'}</p>
                <p className="text-2xl font-bold text-[#FF6B00]">{cat.count}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProduitServiceStats;
